import React, { useState } from 'react';
import LessonSidebar from './LessonSidebar';
import LessonContent from './LessonContent';
import { t } from 'i18next';
import { usePlatformAbilities } from '@/hooks/usePlatformAbilities';
import { useLocation } from 'react-router-dom';
import { Dashboard, DashboardContent } from '@/layouts/dashboard';

export function CreateLesson(props) {
  const { step, contentId, lessonId, courseId } = props;
  const location = useLocation();
  const [currentStep, setCurrentStep] = useState(0);
  const initialModuleId = location?.state?.moduleId;
  const { abilities } = usePlatformAbilities();
  const [isSlide, setIsSlide] = useState(false);

  const steps = [
    {
      id: 0,
      route: 'nome',
      text: t('lessons.stepsLessonName')
    },
    {
      id: 1,
      route: 'videoaula',
      text: t('lessons.stepsLessonVideo')
    }
  ];

  if (abilities?.quiz && !isSlide) {
    steps.push({
      id: 2,
      route: 'perguntas',
      text: t('lessons.stepsLessonQuestions')
    });
  }

  return (
    <Dashboard>
      <LessonSidebar
        disciplineId={contentId}
        moduleId={initialModuleId}
        courseId={courseId}
        currentStep={currentStep}
        steps={steps}
      />

      <DashboardContent viewMode="create">
        <LessonContent
          abilities={abilities}
          courseId={courseId}
          step={step}
          steps={steps}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          learningSystemContentId={contentId}
          lessonId={lessonId}
          moduleId={initialModuleId}
          disciplineId={contentId}
          setIsSlide={setIsSlide}
          isSlide={isSlide}
        />
      </DashboardContent>
    </Dashboard>
  );
}
